
const newPaymentsProcessor= 'enterprise-solutions-new-payments-processor';
const newEraPayments= 'enterprise-solutions-navigating-new-era-payments';
const paymentsInnovation = 'enterprise-solutions-how-payments-innovation-can-help-enterprise-businesses-compete-grow-and-thrive-whitepaper';
const mercatorStudy = 'enterprise-solutions-mercator-study';
const whtAdoptDigitalWallets = 'why-adopt-digital-wallets';
const improveWebsiteUx = 'improve-website-ux';
const protectYourBusiness = 'protect-your-business-from-cybercrime';
const acceptingContactlessPayments = 'benefits-of-accepting-contactless-payments';
const financialReport = 'enterprise-solutions-financial-report';
const commonSlugPair = [improveWebsiteUx, protectYourBusiness];
const type2Pair = [whtAdoptDigitalWallets].concat(commonSlugPair);

const slugIdsCollection = Object.freeze({
  type1: [
    newPaymentsProcessor,
    newEraPayments,
    paymentsInnovation,
    mercatorStudy,
  ],
  type2: type2Pair,
  type3: type2Pair.concat[acceptingContactlessPayments],
  type4: commonSlugPair,
  type5: [whtAdoptDigitalWallets],
  type6: [financialReport]
});

export { slugIdsCollection };
